import { EnvironmentType } from './type';
import packageJson from '../../package.json';

const projectId = 'plwfctenbdwlmplkbmwa';

export const environment = {
  url: 'https://olympiafitnessri.app',
  production: true,
  bugsplat: {
    database: packageJson.database,
    application: packageJson.name,
    version: packageJson.version,
  },
  supabaseUrl: `https://${projectId}.supabase.co`,
  storageUrl: `https://${projectId}.storage.supabase.co`,
  supabaseKey: 'sb_publishable_E299S52Hp86akCW7ESOAJQ_DaI8oKq1',
  oauth: {
    google: {
      web: '527352627850-sulftvcvibgvqlm45b6prm8ouipmntjd.apps.googleusercontent.com',
      ios: '527352627850-dlfbr1jaon5u9tt84v4s1p78a3sqtg7h.apps.googleusercontent.com',
    },
  },
} as EnvironmentType;
